import { connect } from 'react-redux';
import { isLoading } from 'helpers';
import {
  loadGlobalCisCertificateHoldersAttributesCreator,
  loadMaCisCreator,
  removeMaCisCreator,
  removeMaCisFiltersCreator,
  setMaCisFiltersCreator,
  setMaCisPageCreator,
  setMaCisPerPageCreator,
  setMaCisProfileCreator,
  setMaCisSortCreator,
} from '../../../../store/actionsCreators';
import CertificateHolders from '../../../../shared/Cis/CertificateHolders/CertificateHolders';

const mapStateToProps = ({ loading, ma, user }) => ({
  loading: isLoading(loading, 'LOAD_MA_CIS'),
  type: 'ma',
  list: ma.cis.certificateHolders,
  userPermissions: user.userPermissions,
});

const mapDispatchToProps = (dispatch) => ({
  loadList: () => dispatch(loadMaCisCreator('certificateHolders')),
  setPage: (payload) => dispatch(setMaCisPageCreator('certificateHolders', payload)),
  setPerPage: (payload) => dispatch(setMaCisPerPageCreator('certificateHolders', payload)),
  setSort: (payload) => dispatch(setMaCisSortCreator('certificateHolders', payload)),
  setFilters: (payload) => dispatch(setMaCisFiltersCreator('certificateHolders', payload)),
  removeFilters: () => dispatch(removeMaCisFiltersCreator('certificateHolders')),
  setProfile: (payload) => dispatch(setMaCisProfileCreator('certificateHolders', payload)),
  removeCertificateHolder: (payload) => dispatch(removeMaCisCreator('certificateHolders', payload)),
  setCertificatesFilters: (payload) => dispatch(setMaCisFiltersCreator('certificates', payload)),
  loadCertificateHoldersAttributes: () =>
    dispatch(loadGlobalCisCertificateHoldersAttributesCreator()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CertificateHolders);
